var canRender = function canRender(type, types) {
  return types.indexOf(type) !== -1;
};

var Render = function Render(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? '' : _ref$type,
      _ref$types = _ref.types,
      types = _ref$types === undefined ? [] : _ref$types,
      children = _ref.children;
  return children && canRender(type, types) ? children : null;
};

export default Render;